import { createContext, useContext, useState, useEffect } from 'react';
import { legalTranslations } from '@/i18n/legalTranslations';

const translations = {
  es: {
    ...legalTranslations.es,
    loading: "Cargando...",
    save: "Guardar",
    cancel: "Cancelar",
    create: "Crear",
    edit: "Editar",
    delete: "Eliminar",
    confirm: "Confirmar",
    close: "Cerrar",
    search: "Buscar",
    filter: "Filtrar",
    all: "Todos",
    active: "Activos",
    inactive: "Inactivos",
    pending: "Pendiente",
    approved: "Aprobado",
    rejected: "Rechazado",
    inProgress: "En progreso",
    resolved: "Resuelto",
    
    login: "Iniciar Sesión",
    logout: "Cerrar Sesión",
    email: "Email",
    password: "Contraseña",
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    changePassword: "Cambiar Contraseña",
    loginError: "Email o contraseña incorrectos",
    noAccount: "¿No tenés cuenta? Contactá al administrador de tu casa.",
    
    home: "Inicio",
    claims: "Reclamos",
    announcements: "Comunicados",
    benefits: "Beneficios",
    profile: "Perfil",
    visits: "Visitas",
    transfers: "Cambio de casa",
    community: "Comunidad",
    houses: "Casas",
    users: "Usuarios",
    dashboard: "Dashboard",
    settings: "Configuración",
    
    myProfile: "Mi Perfil",
    editProfile: "Editar Perfil",
    name: "Nombre",
    university: "Universidad/Facultad",
    interests: "Intereses",
    nationality: "Nacionalidad",
    shareProfile: "Compartir perfil en Comunidad",
    shareProfileDesc: "Otros usuarios podrán ver tu perfil",
    privateProfile: "Perfil privado",
    publicProfile: "Perfil público",
    socialNetworks: "Redes sociales",
    profilePhoto: "Foto de perfil",
    room: "Habitación",
    sharedRoom: "Compartida",
    exclusiveRoom: "Privada",
    
    myClaims: "Mis Reclamos",
    newClaim: "Nuevo Reclamo",
    claimType: "Tipo de reclamo",
    repair: "Reparación",
    cleaning: "Limpieza",
    noise: "Convivencia",
    other: "Otro",
    claimTitle: "Título",
    claimDescription: "Descripción",
    claimLocation: "Ubicación",
    claimPhoto: "Foto del problema",
    attachPhoto: "Adjuntar foto",
    noClaims: "No tenés reclamos",
    
    recentAnnouncements: "Comunicados Recientes",
    newAnnouncement: "Nuevo Comunicado",
    priority: "Prioridad",
    urgent: "Urgente",
    high: "Alta",
    medium: "Media",
    low: "Baja",
    noAnnouncements: "No hay comunicados",
    
    myBenefits: "Mis Beneficios",
    newBenefit: "Nuevo Beneficio",
    discount: "Descuento",
    businessName: "Nombre del negocio",
    businessAddress: "Dirección",
    validUntil: "Válido hasta",
    noBenefits: "No hay beneficios disponibles",
    forAllHouses: "Para todas las casas",
    
    myVisits: "Mis Visitas",
    requestVisit: "Registrar Visita",
    visitorName: "Nombre del visitante",
    visitorDni: "DNI del visitante",
    visitorPhotoDni: "Foto del DNI",
    visitDate: "Fecha de visita",
    visitDuration: "Duración",
    oneNight: "1 noche",
    weekend: "Fin de semana",
    week: "1 semana",
    notes: "Notas",
    onlyExclusive: "Solo habitaciones privadas pueden solicitar visitas",
    rejectionReason: "Motivo del rechazo",
    
    myTransfers: "Mis Solicitudes de Cambio",
    requestTransfer: "Solicitar Cambio de Casa",
    currentHouse: "Casa actual",
    targetHouse: "Casa destino",
    startDate: "Fecha inicio",
    endDate: "Fecha fin",
    reason: "Motivo",
    
    adminPanel: "Panel Admin",
    totalUsers: "Total Huéspedes",
    totalHouses: "Casas Activas",
    pendingClaims: "Reclamos Pendientes",
    pendingVisits: "Visitas Pendientes",
    pendingTransfers: "Cambios Pendientes",
    activeBenefits: "Beneficios Activos",
    announcementsCount: "Comunicados",
    recentClaims: "Reclamos Recientes",
    analytics: "Analítica",
    occupancyByHouse: "Ocupación por casa",
    monthlyTrend: "Tendencia últimos 6 meses",
    claimsByType: "Reclamos por tipo",
    claimsByHouse: "Reclamos por casa",
    newGuests: "Nuevos huéspedes",
    newClaimsLabel: "Nuevos reclamos",
    totalRooms: "Habitaciones totales",
    activeGuests: "Huéspedes activos",
    roomsOccupied: "habitaciones ocupadas",
    avgResolution: "Tiempo prom. resolución",
    newGuest: "Nuevo Huésped",
    newHouse: "Nueva Casa",
    newAnnouncementBtn: "Nuevo Comunicado",
    newBenefitBtn: "Nuevo Beneficio",
    deactivate: "Dar de baja",
    reactivate: "Reactivar",
    leaseStart: "Inicio contrato",
    leaseEnd: "Fin contrato",
    roomType: "Tipo de habitación",
    address: "Dirección",
    city: "Ciudad",
    rooms: "Habitaciones",
    amenities: "Amenities",
    reads: "lecturas",
    approve: "Aprobar",
    reject: "Rechazar",
    confirmReject: "Confirmar rechazo",
    viewDni: "Ver DNI",
    from: "Desde",
    to: "Hacia",
    inProgressBtn: "En Progreso",
    resolveBtn: "Resolver",
    reopenBtn: "Reabrir",

    savedSuccessfully: "Guardado correctamente",
    errorSaving: "Error al guardar",
    confirmDelete: "¿Estás seguro de que querés eliminar?",
    noResults: "No hay resultados",
  },
  en: {
    ...legalTranslations.en,
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    create: "Create",
    edit: "Edit",
    delete: "Delete",
    confirm: "Confirm",
    close: "Close",
    search: "Search",
    filter: "Filter",
    all: "All",
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    inProgress: "In Progress",
    resolved: "Resolved",
    
    login: "Log In",
    logout: "Log Out",
    email: "Email",
    password: "Password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    changePassword: "Change Password",
    loginError: "Invalid email or password",
    noAccount: "Don't have an account? Contact your house administrator.",
    
    home: "Home",
    claims: "Requests",
    announcements: "Announcements",
    benefits: "Benefits",
    profile: "Profile",
    visits: "Visits",
    transfers: "House Transfer",
    community: "Community",
    houses: "Houses",
    users: "Users",
    dashboard: "Dashboard",
    settings: "Settings",
    
    myProfile: "My Profile",
    editProfile: "Edit Profile",
    name: "Name",
    university: "University",
    interests: "Interests",
    nationality: "Nationality",
    shareProfile: "Share profile in Community",
    shareProfileDesc: "Other users will be able to see your profile",
    privateProfile: "Private profile",
    publicProfile: "Public profile",
    socialNetworks: "Social networks",
    profilePhoto: "Profile photo",
    room: "Room",
    sharedRoom: "Shared",
    exclusiveRoom: "Exclusive",
    
    myClaims: "My Claims",
    newClaim: "New Claim",
    claimType: "Claim type",
    repair: "Repair",
    cleaning: "Cleaning",
    noise: "Coexistence",
    other: "Other",
    claimTitle: "Title",
    claimDescription: "Description",
    claimLocation: "Location",
    claimPhoto: "Problem photo",
    attachPhoto: "Attach photo",
    noClaims: "No claims",
    
    recentAnnouncements: "Recent Announcements",
    newAnnouncement: "New Announcement",
    priority: "Priority",
    urgent: "Urgent",
    high: "High",
    medium: "Medium",
    low: "Low",
    noAnnouncements: "No announcements",
    
    myBenefits: "My Benefits",
    newBenefit: "New Benefit",
    discount: "Discount",
    businessName: "Business name",
    businessAddress: "Address",
    validUntil: "Valid until",
    noBenefits: "No benefits available",
    forAllHouses: "For all houses",
    
    myVisits: "My Visits",
    requestVisit: "Register Visit",
    visitorName: "Visitor name",
    visitorDni: "Visitor ID",
    visitorPhotoDni: "ID Photo",
    visitDate: "Visit date",
    visitDuration: "Duration",
    oneNight: "1 night",
    weekend: "Weekend",
    week: "1 week",
    notes: "Notes",
    onlyExclusive: "Only exclusive rooms can request visits",
    rejectionReason: "Rejection reason",
    
    myTransfers: "My Transfer Requests",
    requestTransfer: "Request House Transfer",
    currentHouse: "Current house",
    targetHouse: "Target house",
    startDate: "Start date",
    endDate: "End date",
    reason: "Reason",
    
    adminPanel: "Admin Panel",
    totalUsers: "Total Guests",
    totalHouses: "Active Houses",
    pendingClaims: "Pending Claims",
    pendingVisits: "Pending Visits",
    pendingTransfers: "Pending Transfers",
    activeBenefits: "Active Benefits",
    announcementsCount: "Announcements",
    recentClaims: "Recent Claims",
    analytics: "Analytics",
    occupancyByHouse: "Occupancy by house",
    monthlyTrend: "Last 6 months trend",
    claimsByType: "Claims by type",
    claimsByHouse: "Claims by house",
    newGuests: "New guests",
    newClaimsLabel: "New claims",
    totalRooms: "Total rooms",
    activeGuests: "Active guests",
    roomsOccupied: "rooms occupied",
    avgResolution: "Avg. resolution time",
    newGuest: "New Guest",
    newHouse: "New House",
    newAnnouncementBtn: "New Announcement",
    newBenefitBtn: "New Benefit",
    deactivate: "Deactivate",
    reactivate: "Reactivate",
    leaseStart: "Lease start",
    leaseEnd: "Lease end",
    roomType: "Room type",
    address: "Address",
    city: "City",
    rooms: "Rooms",
    amenities: "Amenities",
    reads: "reads",
    approve: "Approve",
    reject: "Reject",
    confirmReject: "Confirm rejection",
    viewDni: "View ID",
    from: "From",
    to: "To",
    inProgressBtn: "In progress",
    resolveBtn: "Resolve",
    reopenBtn: "Reopen",

    savedSuccessfully: "Saved successfully",
    errorSaving: "Error saving",
    confirmDelete: "Are you sure you want to delete?",
    noResults: "No results",
  }
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('wanna-language') || 'es';
  });

  useEffect(() => {
    localStorage.setItem('wanna-language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['es']?.[key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
